import StapleFoodConfig, {canChooseCombination, getRandomStapleFood, StapleFoodEntity} from "./config/StapleFoodConfig";
import SwingPlateShop from "./swingPlateShop";
import O1HD from "../../../../engines/gameEngine";
import {getRandomTalkMsg, TALK_TYPE} from "./config/TalkMsgConfig";
import {getFoodMaterialEntityById} from "./config/FoodMaterialConfig";
import gameConfig from "../../../../engines/configs/gameConfig";

/**
 * 摆盘Manager
 */
export default class SwingPlateManager{

    mGameLayer : SwingPlateShop;

    constructor( swingPlateShop : SwingPlateShop ) {
        this.mGameLayer = swingPlateShop;
        O1HD.on("SwingPlateManager.addFoodMaterial" , this.addFoodMaterial , this  );
    }

    //主食
    stapleFood : StapleFoodEntity;
    //选择的 食材 数组
    chooseFoodMaterialArray : number[] = [];
    //当前报价
    currPrice : number = 0;

    //可以选择 食材的 控制开关
    canChooseFoodMaterialFlag : boolean = false;

    /**
     * 进入 顾客
     */
    enterCustomer(){
        this._reset();
        // 获取随机主食
        let stapleFoodEntity : StapleFoodEntity = getRandomStapleFood();//饮品 主食 甜品
        // 获取对应的文案
        let talkMsg = getRandomTalkMsg ( TALK_TYPE.STAPLE_FOOD , stapleFoodEntity.typeName );
        this.currPrice = ( stapleFoodEntity.basicPrice * gameConfig.SWING_PLATE_RATE );
        O1HD.emit("HumanScript.humanEnter" , stapleFoodEntity , talkMsg , (  )=>{
            this.mGameLayer.lbName.string = `${stapleFoodEntity.name}`;
            this.replaceStapleFood( stapleFoodEntity.uniqueId );
        } );
    }

    /**
     * 替换主食
     * @param stapleFoodId 食物id
     */
    replaceStapleFood( stapleFoodId : number ){
        this.stapleFood = StapleFoodConfig().find(( item,index,dataList)=>{ return item.uniqueId == stapleFoodId });
        //UI 替换主食表现
        this.mGameLayer.replaceStapleFood( this.stapleFood ).then();
        this.mGameLayer.scheduleOnce(()=>{
            // console.log("this.currPrice" , this.currPrice );
            O1HD.emit("HumanScript.humanPutPrice" , this.currPrice , `${this.stapleFood.name}，我报这个价` , 3 , ()=>{
                //完成回调
                this.canChooseFoodMaterialFlag = true;
            });
        },0.6 );
    }

    /**
     * 变身金盘子
     */
    changeGoldPlate(){
        if ( !this.canChooseFoodMaterialFlag ) {
            O1HD.getModules().uiControlModule.showMessageBox("请等待操作完毕");
            return;
        }
        this.canChooseFoodMaterialFlag = false;
        this.currPrice += ( 100000 * gameConfig.SWING_PLATE_RATE );
        O1HD.emit("FoodItem.goldPlate");
        O1HD.emit("HumanScript.humanPutPrice" , this.currPrice , "这金盘子瞬间拉伸了一个档次!" , 1 , ()=>{
            //完成回调
            this.canChooseFoodMaterialFlag = true;
        });
    }

    /**
     * 添加食材
     * @param foodId
     */
    addFoodMaterial( foodMaterialId : number , validateCallBack ){
        if ( !this.canChooseFoodMaterialFlag ) {
            //无效点击
            O1HD.getModules().uiControlModule.showMessageBox("请等待此次操作完毕");
            validateCallBack && validateCallBack( false );
            return;
        }
        validateCallBack && validateCallBack( true );
        this.canChooseFoodMaterialFlag = false;
        //放入当前 食材队列
        this.chooseFoodMaterialArray.push( foodMaterialId );
        //添加食材表现
        O1HD.emit( "FoodItem.addFoodMaterial" , foodMaterialId );
        //计算价格， 返回当前的内容
        let ret = this._calCurrentPrice( foodMaterialId );
        //判定是否变身
        this._checkTransformation();
        // Ai反馈
        O1HD.emit("HumanScript.humanPutPrice" , this.currPrice , ret.talkMsg , ret.smileFlag , ()=>{
            // console.log( "完成回调 " , this.chooseFoodMaterialArray.length ) ;
            //完成回调
            if ( this.chooseFoodMaterialArray.length == 3 ) {
                this.canChooseFoodMaterialFlag = false;
                O1HD.getServices().userSrv.setCoins( this.currPrice , true , this.mGameLayer.addNode );
                this.mGameLayer.scheduleOnce(()=>{
                    // 结算，拿走食材，带上表现
                    O1HD.emit("HumanScript.humanOut", ret.smileFlag , ()=>{
                        this.enterCustomer();
                    });
                    // this.mGameLayer.scheduleOnce(()=>{
                    //
                    // },2 );
                    O1HD.emit("FoodItem.takeAway");
                },2 );
            }else{
                this.canChooseFoodMaterialFlag = true;
            }
        });
    }

    /**
     * 判定是否变身
     * @private
     */
    private _checkTransformation (){
        if ( this.chooseFoodMaterialArray.length == 3 ) {
            // 判定 是否变身
            let menuStr : string = this._getMenuStr();
            //判定是否 有套餐 匹配
            let menuEntity = canChooseCombination( menuStr );
            if ( menuEntity && menuEntity.transferFlag ) {
                O1HD.emit("FoodItem.transformation" , menuEntity.name );
            }else{
                // let gwFlag : boolean = true;
                // this.stapleFood.foodMaterialArray.forEach(( item,index ,dataList)=>{
                //     if ( this.chooseFoodMaterialArray.includes(item.id) ) {
                //         gwFlag = false;
                //     }
                // });
                // if ( gwFlag == true ) {
                    this.mGameLayer.lbName.string = `怪味${this.stapleFood.name}`;
                    O1HD.emit("FoodItem.transformation" , "怪味" );
                // }
            }
        }
    }

    /**
     * 变成菜单 字符串
     * @private
     */
    private _getMenuStr(){
        let menuStr : string = `${this.stapleFood.uniqueId}`;
        this.chooseFoodMaterialArray.forEach(( value,index ,dataList )=>{
            menuStr += `-${value}`;
        });
        console.log( `menuStr` , menuStr );
        return menuStr;
    }

    /**
     * 计算当前组合价格 以及对应的文案 和是否开心的标识
     * @private
     */
    private _calCurrentPrice( foodMaterialId : number ) : { talkMsg : string , smileFlag : number }{
        let foodMaterialEntity = getFoodMaterialEntityById( foodMaterialId );
        let menuStr : string = this._getMenuStr();
        //判定是否 有套餐 匹配
        // console.log( `menuStr` , menuStr );
        let menuEntity = canChooseCombination( menuStr );
        // console.log( `menuEntity` , menuEntity );
        if ( menuEntity ) {
            this.mGameLayer.lbName.string = `${menuEntity.name}`;
            //如果套餐内
            let talkMsg = getRandomTalkMsg( TALK_TYPE.SET_MEAL , menuEntity.name );
            // console.log( "套餐" , talkMsg );
            this.currPrice += ( menuEntity.price * gameConfig.SWING_PLATE_RATE );
            return { talkMsg : talkMsg , smileFlag : 1 };
        }else{
            this.mGameLayer.lbName.string = `怪味${this.stapleFood.name}`;
            let talkMsg : string;
            let smileFlag : number = -1;
            //如果套餐外
            if ( this.stapleFood.foodMaterialArray.find((item,index,dataList)=>{ return item.id == foodMaterialId }) ){
                //如果是组合 食材内
                this.currPrice += ( (this.stapleFood.combinationUpPrice + foodMaterialEntity.combinationUpPrice) * gameConfig.SWING_PLATE_RATE ) ;
                if ( this.currPrice < 0 ){
                    this.currPrice = 0;
                }
                talkMsg = getRandomTalkMsg( TALK_TYPE.FOOD_MATERIAL , foodMaterialEntity.name );
                // console.log( "套餐内" , talkMsg );
                smileFlag = 1;
            }else{
                //组合食材外
                talkMsg = getRandomTalkMsg( TALK_TYPE.FOOD_MATERIAL , foodMaterialEntity.name , 1 );
                // console.log( "套餐外" , talkMsg );
                this.currPrice += ( (this.stapleFood.combinationDownPrice + foodMaterialEntity.combinationDownPrice) * gameConfig.SWING_PLATE_RATE );
                if ( this.currPrice < 0 ){
                    this.currPrice = 0;
                }
                smileFlag = 2;
            }
            return { talkMsg : talkMsg , smileFlag : smileFlag };
        }
    }


    private _reset(){
        this.chooseFoodMaterialArray = [];
        this.stapleFood = null;
        this.currPrice = 0;
    }
}
